import { DefaultCommandProps } from './index';

import Base from './base';

const TextInput = ({ value, onChange, label }: DefaultCommandProps) => (
  <Base type="text" value={value} onChange={(e) => onChange(label, e)} id={label} />
);

export default TextInput;
